'use client';
import { useEffect, useRef, useState } from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';

import classes from './FilterComps.module.css';
import { ChevronDown } from 'react-feather';

const Sorting = (props) => {
	const { theSortCriteria } = props;
	const router = useRouter();
	const params = useSearchParams();
	const pathname = usePathname();

	const ref = useRef();

	const [showSorting, setShowSorting] = useState(false);

	const sortOptions = [
		{ criteria: '0', text: 'Relevance' },
		{ criteria: '1', text: 'Price Low To High' },
		{ criteria: '2', text: 'Price High To Low' },
		{ criteria: '3', text: 'Newest' },
		{ criteria: '5', text: 'Most Popular' },
		{ criteria: '6', text: 'Best Deals' },
		{ criteria: '7', text: 'Closest' },
	];

	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			// If the menu is open and the clicked target is not within the menu,
			// then close the menu
			if (showSorting && ref.current && !ref.current.contains(e.target)) {
				setShowSorting(!showSorting);
			}
		};

		document.addEventListener('mousedown', checkIfClickedOutside);

		return () => {
			// Cleanup the event listener
			document.removeEventListener('mousedown', checkIfClickedOutside);
		};
	}, [showSorting]);

	const showSortingHandler = () => {
		setShowSorting(!showSorting);
	};

	const setSortCriteriaHandler = (e) => {
		let newParams = new URLSearchParams(window.location.search);

		newParams.delete('sort');
		router.replace(pathname + '?' + newParams + `&sort=${e}`);

		if (window.innerWidth > 600) {
			setShowSorting(!showSorting);
		}
	};

	const clearSorting = () => {
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('sort');
		router.replace(pathname + '?' + newParams);
	};

	const [innerWidth, setInnerWidth] = useState();

	useEffect(() => {
		setInnerWidth(window.innerWidth);
	}, []);

	return (
		<>
			{innerWidth > 600 ? (
				<div className={classes.sorting} ref={ref}>
					<div
						className={
							showSorting || theSortCriteria
								? classes.dropDownSortActive
								: classes.dropDownSort
						}
						onClick={showSortingHandler}
					>
						<div
							className={
								showSorting || theSortCriteria
									? classes.justifyBetweenSortActive
									: classes.justifyBetweenSort
							}
						>
							{theSortCriteria
								? sortOptions.find((crit) => crit.criteria === theSortCriteria)
										.text
								: 'Relevance'}
							<ChevronDown
								className={showSorting ? classes.flip : classes.icon}
							/>
						</div>

						{showSorting && (
							<div className={classes.boxSort}>
								{sortOptions.map(({ criteria, text }) => (
									<div
										key={criteria}
										className={
											theSortCriteria === criteria
												? classes.activeSort
												: classes.selectionSort
										}
										as="button"
										onClick={() => setSortCriteriaHandler(criteria)}
									>
										{text}
									</div>
								))}
							</div>
						)}
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
};

export default Sorting;
